import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { CheckboxComponent } from '@bcef/ia-components/checkbox';
import { PanelModule } from '@bcef/ia-components/panel';
import { IconsModule } from '@bcef/ia-ng-icons';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';

import { SuccessionFacade } from '@features/succession/succession.facade';

import { SummaryFacade } from './summary.facade';

@DataLayered('dataLayer.summary')
@Component({
  selector: 'ia-succession-summary',
  templateUrl: './summary.component.html',
  imports: [
    AsyncPipe,
    ButtonModule,
    CheckboxComponent,
    FormsModule,
    IconsModule,
    PanelModule,
    TranslateModule,
  ],
  standalone: true,
})
export class SummaryComponent {
  @HostBinding('class') public classAttribute = 'tw-flex tw-flex-col tw-mb-4 sm:tw-mx-24';

  protected readonly summaryFacade = inject(SummaryFacade);

  protected readonly successionFacade = inject(SuccessionFacade);
}
